// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2HnZF","balanceDisclaimer":"posDashboard_balanceDisclaimer__1hNSn"};